import { LanguageSwitcher } from '@/components/LanguageSwitcher/LanguageSwitcher';
import LogoImage from '@/assets/logo.png';
import React from 'react';

type SimpleLayoutProps = {
  children: React.ReactNode;
  headerElement?: React.ReactNode;
};

export const SimpleLayout = ({
  children,
  headerElement,
}: SimpleLayoutProps) => {
  return (
    <div className="flex min-h-screen bg-simple bg-cover bg-fixed bg-center">
      <div className="flex flex-1 flex-col">
        {/* Header */}
        <div className="relative z-10 flex h-[60px] shrink-0">
          <div className="flex flex-1 items-center px-4 py-2">
            <div className="flex flex-1 items-center">
              <a href="/">
                <img src={LogoImage} alt="logo image" className="h-10" />
              </a>
            </div>
            <div className="flex items-center gap-x-3">
              <LanguageSwitcher />
              {headerElement}
            </div>
          </div>
        </div>
        {/* Content */}
        <main className="relative grow focus:outline-none">{children}</main>
      </div>
    </div>
  );
};
